import script from "./entries-table-row.vue?vue&type=script&setup=true&lang=ts"
export * from "./entries-table-row.vue?vue&type=script&setup=true&lang=ts"

import "./entries-table-row.vue?vue&type=style&index=0&id=f8ed1dea&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8ed1dea"]])

export default __exports__